import { PrintDocument } from './document'
import { ResolvedDevice, printTo } from './send'
import { fillSheet, fillTemplate, Template } from './templates/fill'
import { SHEET_LAYOUTS } from './templates/defaults'

export type SheetLayoutKey = keyof typeof SHEET_LAYOUTS

export interface LabelItem {
  data: Record<string, unknown>
  copies: number
}

/**
 * Labels or cards as print jobs (POS.md §18.9): on a label printer, one label job per item with its copies; through
 * the browser (or with a sheet chosen), every copy as a cell of A4 sheets, paged by the renderer.
 */
export const labelDocuments = (template: Template, items: LabelItem[], sheet?: SheetLayoutKey): PrintDocument[] => {
  const live = items.filter((i) => i.copies > 0)
  if (sheet) {
    const cells = live.flatMap((i) => Array.from({ length: i.copies }, () => i.data))
    return cells.length ? [fillSheet(template, cells, SHEET_LAYOUTS[sheet])] : []
  }
  return live.map((i) => fillTemplate(template, i.data, { copies: i.copies }))
}

/** Prints labels on one device; the browser always gets A4 sheets (`labels_3x8` unless another layout is given). */
export const printLabels = async (target: ResolvedDevice, template: Template, items: LabelItem[], sheet?: SheetLayoutKey) => {
  const layout = sheet ?? (target.device.transport === 'browser' ? 'labels_3x8' : undefined)
  for (const doc of labelDocuments(template, items, layout)) await printTo(target, doc, { title: 'Labels' })
}
